import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector, useAppStore } from 'store/hooks';
import { Button, Spacer } from 'design-system';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { InternalTransfer } from 'features/transfers/types';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
import { selectUserCreatedPot } from '../reducers/selectors';
const strings = {
    completedTitle: 'Pot created',
    incompleteTitle: 'Create your first pot',
    desc: 'Create your first pot to start earning interest',
};
const CreateFirstPotProgressCard = ({ status }) => {
    const store = useAppStore();
    const navigation = useMainStackNavigation();
    const pot = useAppSelector(selectUserCreatedPot);
    const hasCreatedPot = pot !== undefined;
    const hasFundedPot = useAppSelector((state) => state.pots.hasFundedPot);
    const hasInitiatedDepositToPot = useAppSelector((state) => state.pots.hasInitiatedDepositToPot);
    const hasFunded = hasFundedPot || hasInitiatedDepositToPot;
    const isActiveStep = !!(status === 'ACTIVE' && (!hasCreatedPot || !hasFunded));
    const completed = !!(status === 'ACTIVE' && hasCreatedPot && hasFunded);
    const handleCreatePot = useCallback(() => {
        if (showUnavailableOnWeb('emma://save?tab=pots', pot ? 'Add money' : 'Create a Pot')) {
            return;
        }
        if (pot) {
            const { connectedAccount } = store.getState().invest;
            if (connectedAccount) {
                navigation.navigateDeprecated('Transfer', {
                    to: pot,
                    from: {
                        ...connectedAccount,
                        itemType: 'investConnectedAccount',
                    },
                    type: InternalTransfer.fund,
                });
            }
            else {
                navigation.navigate('SelectFundingAccount', {
                    pot,
                });
            }
            return;
        }
        navigation.navigateDeprecated('SelectPotType');
    }, [pot]);
    return (<ProgressCard lightBg completed={completed} timeInfo="< 1 minute" isActiveStep={isActiveStep} title={completed ? strings.completedTitle : strings.incompleteTitle}>
      <Text TextThin-14 Secondary>
        {strings.desc}
      </Text>
      {!!isActiveStep && (<>
          <Spacer h={12}/>
          <View style={styles.row}>
            <Button brandLight hug extra square title={hasCreatedPot ? 'Continue' : 'Create pot'} onPress={handleCreatePot}/>
          </View>
        </>)}
    </ProgressCard>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
export default CreateFirstPotProgressCard;
